(function () {
  function updateCartBadges(count) {
    count = Number(count) || 0;

    document.querySelectorAll('.cart-link, [data-item-count]').forEach(function (link) {
      link.dataset.itemCount = String(count);

      var badge = link.querySelector('.cart-link__count');
      if (!badge) return;

      badge.textContent = count;
      badge.classList.toggle('is-empty', count < 1);
      badge.removeAttribute('hidden');
      badge.style.display = count < 1 ? 'none' : 'block';
    });
  }

  function syncCartCountFromServer() {
    return fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartBadges(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function patchMinicart() {
    if (!window.Minicart) {
      return false;
    }

    if (typeof Minicart.updateCartCount === 'function' && !Minicart.updateCartCount.__cartCountPatched) {
      var originalUpdateCartCount = Minicart.updateCartCount.bind(Minicart);

      Minicart.updateCartCount = function () {
        originalUpdateCartCount();
        updateCartBadges(this.state.item_count);
      };

      Minicart.updateCartCount.__cartCountPatched = true;
    }

    return true;
  }

  function patchFetch() {
    if (window.fetch.__cartCountPatched) {
      return;
    }

    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      return originalFetch(input, init).then(function (response) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';

        if (url.indexOf('/cart.js') !== -1 && url.indexOf('view=') === -1) {
          response.clone().json().then(function (cart) {
            if (cart && typeof cart.item_count !== 'undefined') {
              updateCartBadges(cart.item_count);
            }
          }).catch(function () {});
        }

        if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
          syncCartCountFromServer();
        }

        return response;
      });
    };

    window.fetch.__cartCountPatched = true;
  }

  function init() {
    patchMinicart();
    syncCartCountFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  patchFetch();

  document.addEventListener('minicartReloaded', function () {
    if (window.Minicart && Minicart.state && typeof Minicart.state.item_count !== 'undefined') {
      updateCartBadges(Minicart.state.item_count);
    } else {
      syncCartCountFromServer();
    }
  });

  window.updateCartBadges = updateCartBadges;
})();
